<template>
    <section class="user-center">
        <div class="content">
            <div class="left">
                <ul class="left-nav">
                    <li :class="activeNav=='nav1'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav1'">用户信息</li>
                    <li :class="activeNav=='nav2'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav2'" v-if="!loginAsChild||loginAsChild=='false'">子账号管理</li>
                    <li :class="activeNav=='nav3'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav3'">修改密码</li>
                    <li :class="activeNav=='nav4'?'left-nav-item active':'left-nav-item'" @click="activeNav='nav4'"  v-if="!loginAsChild||loginAsChild=='false'">订单提醒设置</li>
                </ul>
            </div>
            <div class="right">
                <!-- right-content -->
                <div :class="activeNav=='nav1'?'right-content active':'right-content'"  >
                    <div class="right-content-head">
                        用户信息
                    </div>
                    <div class="right-content-body">
                        <p>企业名称：{{userInfo.SupplierName}}</p>
                        <p>注册账号：{{userInfo.userName}}</p>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav2'?'right-content active':'right-content'"  @click="activeNav='nav2'"  v-if="!loginAsChild||loginAsChild=='false'"> 
                    <div class="right-content-head">
                        子账户管理
                        <a class="head-btn allot-child-accont-btn" @click="toAllotChildAccount">分配子账号</a>
                    </div>
                    <div class="right-content-body">
                        <div class="filter">
                            <div class="form-inline-contorl">
                                <label class="title">编号：</label>
                                <input type="text" v-model="subUserNo" />
                            </div>
                            <div class="form-inline-contorl">
                                <label class="title">姓名：</label>
                                <input type="text" v-model="subUserName">
                            </div>
                            <div class="form-inline-contorl">
                                <label class="title">状态：</label>
                                <select name="" id="" v-model="subUserStatus">
                                    <option :value="true">启用</option>
                                    <option :value="false">禁用</option>
                                </select>
                            </div>
                            <div class="form-inline-contorl e-pull-right">
                                <div class="search-btn" @click="getSubUserList">查询</div>
                            </div>
                        </div>
                        <table class="child-accont-table" cellspacing="0">
                            <thead>
                                <tr> 
                                    <td width="15%">编号</td>
                                    <td width="10%">姓名</td>
                                    <td width="15%">电话</td>
                                    <td width="15%">传真</td>
                                    <td width="10%">当前状态</td>
                                    <td width="35%">操作</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in subUserList" v-if="user.NO.indexOf(subUserNo)>-1&&user.Name.indexOf(subUserName)>-1&&subUserStatus==user.IsActive">
                                    <td>
                                        {{user.NO}}
                                        <!-- <span>{{user.NO}}</span> -->
                                    </td>
                                    <td>
                                        {{user.Name}}
                                       
                                    </td>
                                    <td>{{user.Phone}}</td>
                                    <td>{{user.Fax}}</td>
                                    <td> 
                                        <span v-if="user.IsActive">已启用</span>
                                        <span v-if="!user.IsActive">未启用</span>
                                        
                                    </td>
                                    <td>
                                        <!-- <a href="javascript:void(0)">删除</a> -->
                                        <a @click="toAllotUserAuth(user)">分配权限</a>
                                        <a @click="toAllotHotels(user)">分配酒店</a>
                                        <a @click="toResetPassword(user)">重置密码</a>
                                        <a @click="eidtSubUser(user.NO,true,user.Permissionons)" v-if="!user.IsActive">启用</a>
                                        <a  @click="eidtSubUser(user.NO,false,user.Permissionons)" v-if="user.IsActive">禁用</a>
                                    </td>
                                </tr>
                                <tr v-if="!subUserList||subUserList.length<=0">
                                    <td colspan="6">没有相关数据</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav3'?'right-content active':'right-content'"  @click="activeNav='nav3'">
                    <div class="right-content-head">
                        修改密码
                    </div>
                    <div class="right-content-body">
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title">原密码：</label>
                                <input type="password" v-model="OldPwd" />
                            </div>
                            <div class="form-contorl">
                                <label class="title">新密码：</label>
                                <input type="password" v-model="NewPwd" />
                            </div>
                            <div class="form-contorl">
                                <label class="title">确认密码：</label>
                                <input type="password" v-model="NewPwd2" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updatePassword">提交</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- right-content -->
                <div :class="activeNav=='nav4'?'right-content active':'right-content'"  @click="activeNav='nav4'"  v-if="!loginAsChild||loginAsChild=='false'">
                    <div class="right-content-head">
                        订单提醒设置
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">短信提醒设置</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title">手机号码：</label>
                                <input type="text" v-model="Phone" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updateNotifyPhone">提交</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">邮件提醒设置</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <label class="title">邮箱号码：</label>
                                <input type="text" v-model="Email" />
                            </div>
                            <div class="form-contorl">
                                <label class="title"></label>
                                <div class="submit-btn" @click="updateNotifyEmail">提交</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-content-body">
                        <div class="subTitle">微信提醒设置</div>
                        <div class="e-form">
                            <div class="form-contorl">
                                <p>1、关注微信公众号“龙腾捷旅订房集团”；</p>
                                <p>2、点击“系统登录”，进入“控房易”；</p>
                                <p>3、使用用户名与密码登录系统；</p>
                                <p>4、点击“我的信息”，打开“是否接受订单通知”</p>
                            </div>
                        </div>
                    </div>
                </div>

                <section class="section-footer">
                    <p>预订及售后电话（酒店专用）：020-2214 6801  国内产品：0755-82365588-1  香港产品：0755-82365588-2  海外产品：0755-82365588-3  澳门产品：0756-8281308</p>
                    <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a> <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
                </section>
            </div>

        </div>
        <AllotChildAccount :userInfo="userInfo" @done="getSubUserList"> </AllotChildAccount>
        <AllotUserAuth :userAuth="userAuth" @done="getSubUserList"> </AllotUserAuth>
        <AllotHotels :userHotel="userHotel" @done="getSubUserList"> </AllotHotels>
        <ResetPassword :userPwd="userPwd" @done="getSubUserList"> </ResetPassword>
    </section>
</template>

<script>
import AllotChildAccount from './AllotChildAccont.vue'
import AllotUserAuth from './AllotUserAuth.vue'
import AllotHotels from './AllotHotels.vue'
import ResetPassword from './ResetPassword.vue'
export default {
    name: 'user',
    components:{
        AllotChildAccount,
        AllotUserAuth,
        AllotHotels,
        ResetPassword
    },
    data () {
        return {
            userInfo:JSON.parse(this.dao.get('res')),
            userAuth:JSON.parse(this.dao.get('res')),
            userHotel:JSON.parse(this.dao.get('res')),
            userPwd:JSON.parse(this.dao.get('res')),
            activeNav:'nav1',
            subUserList:'',
            //子账户管理
            subUserNo:'',
            subUserName:'',
            subUserStatus:true,
            //主帐号管理
            OldPwd:'',
            NewPwd:'',
            NewPwd2:'',
            //短信提醒
            Phone:'',
            // 邮箱提醒
            Email:'',
            loginAsChild:this.dao.get('loginAsChild')
        }
    },
    watch:{
        $route(val){
          
            this.activeNav=val.query.activeNav||'nav1';

        }
    },

    methods:{
        toAllotChildAccount(){
            this.$nextTick(function () {
                this.$set(this.userInfo,'isShow',true);
        　  });
        },
        toAllotUserAuth(user){
            this.userAuth=user;
            this.$nextTick(function () {

                this.$set(this.userAuth,'isAuthShow',true);
        　  });
        },
        toAllotHotels(user){
            this.userHotel=user;
            this.$nextTick(function () {
                this.$set(this.userHotel,'isHotelShow',true);
        　  });
        },
        toResetPassword(user){
            this.userPwd=user;
            this.$nextTick(function () {
                this.$set(this.userPwd,'isPwdShow',true);
        　  });
        },

        getSubUserList(){           
            var that=this;
            that.getRequest({
                url: that.Api.getSubUserList
            }).then(res => {
                if (res&&res.Result.length>0) {
                   
                    that.subUserList=res.Result;
                } else {
                    that.subUserList=[];
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
        eidtSubUser(number,status,permission){           
            var that=this;
            var params={
                NO:number,
                IsActive:status,
                Pwd:'',
                Permissions:permission,
                Hotels:null
            }
            that.patchRequest({
                url: that.Api.eidtSubUser,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: '提示', content: '更新成功' });
                    that.getSubUserList();
                } else {
                    that.error({ title: '提示', content: '更新出错，请重试' });
                }
            });
        },
        getNotifyPhone(){
            var that=this;
            that.getRequest({
                url: that.Api.getNotifyPhone
            }).then(res => {
                if (res&&res.Result) {
                    that.Phone=res.Result;
                } else {
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
        getNotifyEmail(){
            var that=this;
            that.getRequest({
                url: that.Api.getNotifyEmail
            }).then(res => {
                if (res&&res.Result) {
                    that.Email=res.Result;
                } else {
                    // that.error({ title: '提示', content: '没有查询到相关数据' });
                }
            });
        },
        updateNotifyPhone(){
            var that=this;
            const reg = /^1[3-9]\d{9}$/;
            if (!reg.test(that.Phone)) {
                that.error({ title: '提示', content: '手机号码格式不正确' });
                return;
            }
            var params={
                Phone:that.Phone
            };

            that.postRequest({
                url: that.Api.updateNotifyPhone,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: '提示', content: '更新成功' });
                    that.activeNav='nav1';
                    that.getNotifyPhone();
                    that.getNotifyEmail();
                } else {
                    that.error({ title: '提示', content: '更新失败' });
                }
            });
        },

        updateNotifyEmail(){
            var that=this;
            const reg = /^[^\s]+@[a-z0-9]+\.[a-z]{2,4}$/;
            if (!reg.test(that.Email)) {
                that.error({ title: '提示', content: '邮箱格式不正确' });
                return;
            }
            var params={
                Email:that.Email
            };

            that.postRequest({
                url: that.Api.updateNotifyPhone,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: '提示', content: '更新成功' });
                    that.activeNav='nav1';
                    that.getNotifyPhone();
                    that.getNotifyEmail();
                } else {
                    that.error({ title: '提示', content: '更新失败' });
                }
            });
        },


        updatePassword(){

            var that=this;
            var OldPwd=that.OldPwd;
            var NewPwd=that.NewPwd;
            var NewPwd2=that.NewPwd2;

            if(!OldPwd){
                that.error({title: '更新错误',content: '请输入旧密码'})
                return;
            }
            if(!NewPwd){
                that.error({title: '更新错误',content: '请输入新密码'})
                return;
            }
            if(NewPwd.length<6||NewPwd.length>32){
                that.error({title: '更新错误',content: '账号密码长度最小6位, 最大 32 位'})
                return;
            }
            if(!NewPwd2){
                that.error({title: '更新错误',content: '请输入确认密码'})
                return;
            }
            if(NewPwd!=NewPwd2){
                that.error({title: '更新错误',content: '两次密码输入不同'})
                return;
            }


            var params={
                OldPwd:OldPwd,
                NewPwd:NewPwd,
                NewPwd2:NewPwd
            }
            that.postRequest({
                url: that.Api.updatePassword,
                params:params
            }).then(res => {
                if (res&&res.IsSuccess) {
                    that.error({ title: '提示', content: '更新成功'  });
                    that.activeNav='nav1';
                } else {
                    that.error({ title: '提示', content: res.Msg||'更新出错，请重试' });
                }
            });
        }
    },
    mounted(){
      this.getSubUserList();
      this.getNotifyPhone();
      this.getNotifyEmail();
      this.activeNav=this.$route.query.activeNav||'nav1';
    }
}
</script>





// WEBPACK FOOTER //
// src/components/user/User.vue